/* MIXINS */
import roleKeysConst from '@mixins/const/roleKeysConst';

/* SERVICES */
import roleService from '@services/roleService';

export default {
  mixins: [roleKeysConst],
  data() {
    return {
      roles: [],
    };
  },
  mounted() {
    roleService.roleStorage().then((data) => (this.roles = data));
  },
  computed: {
    loadingRoles() {
      return this.roles === undefined || this.roles.length === 0;
    },
    rolesWithLabel() {
      if (!this.roles || !this.roles.length) return [];
      return this.roles
        .filter((role) => {
          if (this.isGas()) return role.type === 'GAS';
          if (this.isGav()) return role.type === 'GAV';
          return false;
        })
        .map((role) => {
          const roleKey = this.roleKeysConst.find((r) => r.value === role.technicalName);
          return {value: role.id, label: roleKey?.label ?? role.technicalName};
        });
    },
  },
  methods: {
    displayForRole(id, returnLabel = '') {
      let result = this.roles.find((role) => role.id === id);
      return result ? result.name : returnLabel;
    },
  },
};
